module.exports = __webpack_public_path__ + "static/media/ms_sans_serif.1d4d404a.woff2";